import React, { ReactElement } from 'react';
import { HashLink } from 'react-router-hash-link';

function Footer(): ReactElement {
  return (
    <>
      {/* Footer */}
      <footer className="py-10 border-t border-slate-200/60">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-600">
            <div className="flex items-center gap-2">
              <div className="h-6 w-6 rounded-lg bg-gradient-to-br from-orange-500 to-amber-400" />
              <span>FlatJSON</span>
              <span className="opacity-60">·</span>
              <span>© {new Date().getFullYear()}</span>
            </div>
            <div className="flex items-center gap-4">
              <HashLink to="/#features" className="hover:text-slate-900">
                Features
              </HashLink>
              <HashLink to="/#how" className="hover:text-slate-900">
                Docs
              </HashLink>
              <HashLink to="/#pricing" className="hover:text-slate-900">
                Pricing
              </HashLink>
              <HashLink to="#" className="hover:text-slate-900">
                Terms
              </HashLink>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
